module.exports = __webpack_public_path__ + "img/logo_logined@2x.7c70fc0d.png";